import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { jordanClients, internationalClients } from '@/data/clients';
import LogoMarquee from '@/components/common/LogoMarquee';

const ClientsSection = () => {
  return (
    <section className="py-20 relative bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-sm font-semibold text-[#398024] tracking-wider uppercase mb-3">Our Clients</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Organisations that work with MAYAN
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Public institutions, industrial operators, and organisations in Jordan, with additional clients outside Jordan.
          </p>
        </motion.div>

        <div className="relative space-y-8">
          <div className="absolute left-0 top-0 bottom-0 w-24 md:w-32 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-24 md:w-32 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />
          <LogoMarquee items={jordanClients} duration={28} />
          <LogoMarquee items={internationalClients} reverse duration={32} />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <Link
            to="/clients"
            className="inline-block bg-white rounded-2xl px-8 py-4 border border-gray-200 text-gray-700 font-medium hover:border-[#398024] hover:text-[#398024] transition-colors"
          >
            View all clients
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsSection;
